import { MDSIconButton, MDSIconButtonSize, MDSIconButtonVariant, MDSIconKind } from "@/mds";

type TProps = {
  navigateBack: () => void;
  navigateForward: () => void;
  canNavigateBack: boolean;
  canNavigateForward: boolean;
};

export const BackForwardButtons = ({
  navigateBack,
  navigateForward,
  canNavigateBack,
  canNavigateForward,
}: TProps) => {
  return (
    <>
      <MDSIconButton
        variant={MDSIconButtonVariant.OnChrome}
        size={MDSIconButtonSize.Medium}
        iconKind={MDSIconKind.LeftArrow}
        onClick={navigateBack}
        isDisabled={!canNavigateBack}
      />
      <MDSIconButton
        variant={MDSIconButtonVariant.OnChrome}
        size={MDSIconButtonSize.Medium}
        iconKind={MDSIconKind.RightArrow}
        onClick={navigateForward}
        isDisabled={!canNavigateForward}
      />
    </>
  );
};
